import { render } from "./TopicsSummaryTable.vue?vue&type=template&id=65c66682&scoped=true&lang=pug"
import script from "./TopicsSummaryTable.vue?vue&type=script&lang=js"
export * from "./TopicsSummaryTable.vue?vue&type=script&lang=js"

import "./TopicsSummaryTable.vue?vue&type=style&index=0&id=65c66682&lang=scss&scoped=true"
import "./TopicsSummaryTable.vue?vue&type=style&index=1&id=65c66682&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c66682"]])

export default __exports__